// @flow

// Helper function that adds clinicLabel and significant support reduce manual checks.

import type { Ask, RawAnswer, Limit } from '../../types';

type Question = {
  id?: string,
  label?: string,
  description?: string,
  optional?: boolean,
  expires?: number,
  min?: number | Limit,
  max?: number | Limit,
  unit?: string,
  clinicLabel?: string,
  hide?: boolean,
  warn?: boolean,
};

type ExtendedNumber = {
  ask: Ask,
  significant: RawAnswer[],
  question: Question,
};

const extendedNumber = async ({
  ask,
  significant,
  question,
}: ExtendedNumber) => {
  const {
    id,
    label,
    description,
    optional,
    expires,
    min,
    max,
    unit,
    clinicLabel,
    hide,
    warn,
  } = question;

  const rawQuestion = {
    id,
    type: 'number',
    label,
    description,
    optional,
    expires,
    min,
    max,
    unit,
  };
  const answer = await ask(rawQuestion);

  if (!hide === true) {
    significant.push({
      type: 'number',
      label: clinicLabel !== undefined ? clinicLabel : question.label,
      value: answer,
      warn,
      unit,
    });
  }

  return answer;
};

export default ({
  ask,
  significant,
}: {
  ask: Ask,
  significant: RawAnswer[],
}) => (question: Question) => extendedNumber({ ask, significant, question });
